// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewBatchId } from './BrewBatch';
import { testInstanceId } from './TestInstance';
import { z } from 'zod';
export const batchClearanceRecordTestLinkId = (z.number());
export const batchClearanceRecordTestLink = z.object({
    id: batchClearanceRecordTestLinkId,
    brew_batch_id: brewBatchId,
    test_instance_id: testInstanceId,
    was_mandatory: z.boolean().nullable(),
    relevance_to_decision: z.string().nullable(),
});
export const batchClearanceRecordTestLinkInitializer = z.object({
    id: batchClearanceRecordTestLinkId.optional(),
    brew_batch_id: brewBatchId,
    test_instance_id: testInstanceId,
    was_mandatory: z.boolean().optional().nullable(),
    relevance_to_decision: z.string().optional().nullable(),
});
export const batchClearanceRecordTestLinkMutator = z.object({
    id: batchClearanceRecordTestLinkId.optional(),
    brew_batch_id: brewBatchId.optional(),
    test_instance_id: testInstanceId.optional(),
    was_mandatory: z.boolean().optional().nullable(),
    relevance_to_decision: z.string().optional().nullable(),
});
//# sourceMappingURL=BatchClearanceRecordTestLink.js.map